<script>
  import { Button, Icon, Modal, ModalFooter, ModalHeader, ModalBody } from '@sveltestrap/sveltestrap'

  import { I18n } from "i18n-js"
  import i18n_translations from "../../javascript/locales.json"

  const i18n = new I18n(i18n_translations)
  i18n.locale = RailsApp.I18n.locale

  let { RailsApp, flash } = $props()

  let open = $derived(flash.alert)
  const toggle = () => (open = !open)
</script>

<Modal isOpen={open} {toggle}>
  <ModalHeader class="text-bg-danger border-0">{i18n.t('form_errors.error')}</ModalHeader>
  <ModalBody class="text-bg-danger">{@html flash.alert}</ModalBody>
  <ModalFooter class="text-bg-danger">
    <Button size="sm" color="outline-light" on:click={toggle}>OK</Button>
  </ModalFooter>
</Modal>
